import { get, useFormContext } from 'react-hook-form';
import { Error } from '@components/error/src/error';
import { ErrorMessageProps } from '@components/error/src/error.types';

export const ErrorMessage = ({ name, dataTestId, className }: ErrorMessageProps) => {
  const { formState } = useFormContext();

  const error = get(formState.errors, name);

  if (!error) {
    return null;
  }

  const { message } = error;

  return (
    <Error dataTestId={dataTestId} className={`text-critical-no-bg text-body-xs ${className}`}>
      {message}
    </Error>
  );
};
